module.exports = __webpack_public_path__ + "static/media/Хадур Махмуд  (КФА).5374693f.pdf";